import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="sections">
      <div className="page-hero notfound">
        <h1 className="page-title">Out of bounds.</h1>
        <p className="page-blurb">
          This page sailed past the back line and nobody called it. Head back
          home, or if your reflexes are feeling sharp, there's a secret court
          hiding at <span className="mono-hint">/play</span>.
        </p>
        <Link className="text-link" to="/" style={{ marginTop: 28 }}>
          <ArrowLeft size={18} weight="bold" /> Back home
        </Link>
      </div>
    </div>
  );
}
